import {connect} from 'react-redux';
import {Component} from 'react';
import injectSheet from 'react-jss';
import qs from 'query-string';

import NavigationService from '-/services/NavigationService';
import WhenIdle from './../general/WhenIdle';
import PhoneCallout from './../general/PhoneCallout';
import HeaderImage from './../general/HeaderImage';
import {getContactSVGUrl, getCreditorBySegment} from '-/api/api';
import {getOfferId, isStipsMode} from '-/util/util';
import UIService from '-/services/UIService';
import {center, fadeout, rem, smallScreen} from '-/styles/utils';
import SessionService from '-/services/SessionService';

const styles = theme => ({
    root: {
        position: 'relative',
        overflow: 'hidden'
    },
    leftContainer: {
        position: 'absolute',
        left: rem(15),
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'table',
        tableLayout: 'fixed',
        ...smallScreen({
            left: rem(5)
        }),
        '& > *': {
            display: 'table-cell',
            verticalAlign: 'middle'
        }
    },
    changeApplicant: {
        color: 'white',
        backgroundColor: theme.colors.secondary,
        padding: rem(5),
        fontSize: '0.875rem',
        fontWeight: 'normal',
        lineHeight: '1.25rem',
        borderRadius: rem(15),
        border: '1px solid white',
        boxShadow: '0 5px 4px rgba(0, 0, 0, 0.19)',
        textAlign: 'center',
        ...smallScreen({
            width: rem(75)
        })
    },
    saveIcon: {
        fontSize: rem(30),
        color: 'white',
        paddingLeft: rem(15),
        ...fadeout()
    },
    backLink: {
        ...center('vertical'),
        left: rem(24),
        fontSize: rem(20),
        fontWeight: 'normal',
        lineHeight: rem(20),
        color: 'white',
        zIndex: 2,
        '&:active, &:focus, &:hover': {
            color: 'white'
        }
    },
    article: {
        left: '50%',
        top: theme.header.top,
        width: '100%',
        transform: 'translate(-50%, -50%)',
        position: 'absolute',
        fontFamily: theme.fontFamily,
        color: theme.colors.header,

        '& h1, & h4, & h5': {
            margin: 0,
            textAlign: 'center'
        },

        '& h1': {
            fontSize: rem(26),
            fontWeight: 'normal',
            lineHeight: rem(26),
            textTransform: 'capitalize'
        },

        '& h4, & h5': {
            fontSize: rem(14),
            fontWeight: 'normal',
            lineHeight: rem(20)
        }
    }
});

const queryParams = qs.parse(location.search);
const {segmentId = ''} = queryParams;
const offerId = getOfferId();
let {creditorId = ''} = queryParams;

const IdlePhoneCallout = (props = {}) => {
    const {isCCRDomain, phone} = props;

    if (isCCRDomain) {
        return null;
    }

    return (
        <WhenIdle>
            <PhoneCallout number={phone} svgUrl={getContactSVGUrl()} />
        </WhenIdle>
    );
};

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            creditorId
        };

        this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    }

    componentDidMount = async() => {
        if (segmentId) {
            const {creditorId} = await getCreditorBySegment({segmentId});

            this.setState({
                creditorId
            });
        }
    };

    renderLeftsideContainer() {
        const {coAppUnlocked, reachedCoApp, currentStep, classes={}} = this.props;
        let changeApplicantMarkup = null;
        const stepsAllowingSwitch = ['buyerInfo', 'employmentInfo', 'additionalIncome'];
        const showButton = coAppUnlocked && stepsAllowingSwitch.indexOf(currentStep) > -1;
        if (showButton) {
            const applicantText = `Switch to ${!reachedCoApp ? 'Co-' : ''}Applicant`;
            changeApplicantMarkup = (
                <h5 className={classes.changeApplicant}>
                    <a onClick={() => NavigationService.toggleCoApplicant(!reachedCoApp)}>{applicantText}</a>
                </h5>
            );
        }
        return (
            <div className={classes.leftContainer}>
                {changeApplicantMarkup}
            </div>
        );
    }

    handleBackButtonClick() {
        const {currentStep} = this.props;
        switch (currentStep) {
            case 'callback':
            case 'addCoApp':
            case 'submit':
            case 'stipEdit':
                NavigationService.goBack();
                break;
            case 'finalQuestions':
                NavigationService.back('finalReview');
                break;
            default:
                NavigationService.back('validationInfo');
                break;
        }
    }

    render() {
        const {
            currentStep,
            isCCRDomain,
            validationOptions,
            contactPhone,
            status,
            pageType,
            classes = {}
        } = this.props;

        ({creditorId} = this.props);

        if (currentStep === 'stipsWelcome') {
            return null;
        }

        if (segmentId) {
            ({creditorId} = this.state);
        }

        if (currentStep === 'hero') {
            const isSubmitted = status === 'SUBMITTED' && !isStipsMode();
            const compactHeader = ['compact'].includes(pageType);
            const imageType = compactHeader ? 'formHeaderImg' : 'homeHeaderImg';
            const submittedImageType = (compactHeader && isSubmitted) ? 'formHeaderImg' : 'homeHeaderImgSubmitted';
            const imageName = isSubmitted ? submittedImageType : imageType;
            return (
                <section className={classes.root}>
                    <HeaderImage name={imageName} offerId={offerId} creditorId={creditorId} />
                    <IdlePhoneCallout phone={contactPhone} isCCRDomain={isCCRDomain} />
                </section>
            );
        }

        const backBtnList = [
            'verifySSN',
            'verifyDob',
            'verifyAccount',
            'verifyAddress',
            'addCoApp',
            'finalQuestions',
            'submit',
            'stipEdit'
        ];

        let showBackBtn = backBtnList.indexOf(currentStep) > -1;

        if (validationOptions && validationOptions.length === 1) {
            showBackBtn = false;
        }

        if (currentStep === 'callback') {
            showBackBtn = true;
        }

        return (
            <section className={classes.root} style={{minHeight:'74.4219px'}}>
                <HeaderImage name="formHeaderImg" offerId={offerId} creditorId={creditorId} />
                {showBackBtn && (
                    <a
                        onClick={this.handleBackButtonClick}
                        className={classes.backLink}
                        title="Go Back">
                        <i className="fa fa-chevron-left" />
                    </a>
                )}
                {this.renderLeftsideContainer()}
                <IdlePhoneCallout phone={contactPhone} isCCRDomain={isCCRDomain} />
            </section>
        );
    }
}

const mapStateToProps = state => {
    const {config, creditor, navigation} = state;
    const {currentStep, reachedCoApp, coAppUnlocked} = navigation;
    const {validationOptions, contactPhone} = config;
    const isCCRDomain = SessionService.isCCRDomain();
    const {_id} = creditor;

    return {
        creditorId: _id,
        currentStep,
        isCCRDomain,
        reachedCoApp,
        coAppUnlocked,
        validationOptions,
        contactPhone,
        status: UIService.getStatus()
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(Header));
